import { InvalidContractParameterTypeError, InvalidContractParameterTypeJSONError } from '../errors';
export var ContractParameterTypeModel;
(function (ContractParameterTypeModel) {
    ContractParameterTypeModel[ContractParameterTypeModel["Signature"] = 0] = "Signature";
    ContractParameterTypeModel[ContractParameterTypeModel["Boolean"] = 1] = "Boolean";
    ContractParameterTypeModel[ContractParameterTypeModel["Integer"] = 2] = "Integer";
    ContractParameterTypeModel[ContractParameterTypeModel["Hash160"] = 3] = "Hash160";
    ContractParameterTypeModel[ContractParameterTypeModel["Hash256"] = 4] = "Hash256";
    ContractParameterTypeModel[ContractParameterTypeModel["ByteArray"] = 5] = "ByteArray";
    ContractParameterTypeModel[ContractParameterTypeModel["PublicKey"] = 6] = "PublicKey";
    ContractParameterTypeModel[ContractParameterTypeModel["String"] = 7] = "String";
    ContractParameterTypeModel[ContractParameterTypeModel["Array"] = 16] = "Array";
    ContractParameterTypeModel[ContractParameterTypeModel["Map"] = 18] = "Map";
    ContractParameterTypeModel[ContractParameterTypeModel["InteropInterface"] = 240] = "InteropInterface";
    ContractParameterTypeModel[ContractParameterTypeModel["Void"] = 255] = "Void";
})(ContractParameterTypeModel || (ContractParameterTypeModel = {}));
export const isContractParameterType = (value) => ContractParameterTypeModel[value] !== undefined;
export const assertContractParameterType = (value) => {
    if (isContractParameterType(value)) {
        return value;
    }
    throw new InvalidContractParameterTypeError(value);
};
export const toJSONContractParameterType = (type) => assertContractParameterTypeJSON(ContractParameterTypeModel[type]);
const isContractParameterTypeJSON = (value) => ContractParameterTypeModel[value] !== undefined;
export const assertContractParameterTypeJSON = (value) => {
    if (isContractParameterTypeJSON(value)) {
        return value;
    }
    throw new InvalidContractParameterTypeJSONError(value);
};
export const toContractParameterType = (value) => assertContractParameterType(ContractParameterTypeModel[value]);

//# sourceMappingURL=ContractParameterTypeModel.js.map
